import React from 'react';
import {Spin, Row, Col, Anchor,Table,Icon} from 'antd';
import Img from 'react-image';
import BookNow from './BookNow';
import App from './App';
import pic from './400.jpg'
import {connect} from 'react-redux';
import {packsel} from './reducers.js'
import Responsive from 'react-responsive-decorator';
import roomc1 from './roomc1.jpg';
import roomc2 from './roomc2.jpg';
import packc1 from './packc1.jpg';
import packc2 from './packc2.jpg';
var Carousel = require('react-responsive-carousel').Carousel;


 class SinglePack extends React.Component{
  constructor(props){
    super(props);
    this.state={
      dir:'row',
      cent:'',
      price:'',
      title:'',
      type:'',
    }
  }
  componentDidMount(){
    window.scrollTo(0,0);
    const prop = this.props.data;
    this.setState({title:prop.title,price:prop.price,type:prop.type});

    this.props.media({ maxWidth: 768 }, () => {
    this.setState({
      dir:'column',cent:'center'
    })
  });
  this.props.media({ minWidth: 768 }, () => {
  this.setState({
    dir:'row',cent:''
  })
});
  }


  render(){
    const prop = this.props.data;
    console.log("props",prop);
    console.log(Number(prop.price))
    const items=[];
        if(prop.type=='room'){
          for(let i =0; i<1;i++){
            items.push(<div><Img src={prop.no%2==0?roomc1:roomc2} style={{width:'100%'}} loader={<div style={{padding:10,margin:'auto',width:'100%',textAlign:'center'}}><Spin size="large" /></div>}/></div>)
          }
        }
        else{
          for(let i =0; i<1;i++){
            items.push(<div><Img src={pic} style={{width:'100%'}} loader={<div style={{padding:10,margin:'auto',width:'100%',textAlign:'center'}}><Spin size="large" /></div>}/></div>)
          }
        }

  const columns = [
    { title: '', dataIndex: 'name', key: 'name' },

  ];

  const expandedRowRender = () => {
    const columns = [
      { title: 'Date', dataIndex: 'date', key: 'date' },
      { title: 'Name', dataIndex: 'name', key: 'name' },

    ];

    const data = [];
    for (let i = 0; i < 3; ++i) {
      data.push({
        key: i,
        date: 'Time',
        name: 'event',
      });
    }
    return (
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
      />
    );
  };
  const data = [];
  for (let i = 1; i < 4; ++i) {
    data.push({
      key: i,
      name: 'Day '+i,

    });
  }




    return(
      <div style={{marginTop:31,background: '#fff',width:'auto',height:'auto'}}>

        <div style={{display:'flex',flexDirection:this.state.dir,alignItems:this.state.cent }}>
          <div style={{maxWidth:1100}}>
            <Carousel>
              {items}
            </Carousel>
            <div style={{display:'flex',flexDirection:this.state.dir,marginTop:40}}>
              <div style={{display:'flex',flexDirection:'column',justifyContent:'flex-start',alignItems:'center',minWidth:150,marginTop:10}}>
                  <div><h1>Details:</h1></div>
                  <div style={{background:'#0792EF',width:'50%',height:1,marginTop:2}} />
              </div>
              <div style={{margin:20,display:'flex',flexDirection:'column',}}>
                  <div style={{display:'flex',flexDirection:this.state.dir,justifyContent:'space-between',}}>
                    <h2>{this.state.title}</h2>
                      <div style={{textAlign:'center',margin:5,display:'box',borderRadius:5,backgroundColor:'#1DA57A',width:'auto',height:'80%',color:'#ffffff',padding:8}}>
                        ₹{this.state.price} {this.state.type=='room'? '/ day': null}
                      </div>
                  </div>
                  <p style={{margin:20,fontSize:14}}>
                    Wayanad Cliff Hotels Apartments is a self-catering accommodation located in Kalpatta. Free WiFi access is available in the rooms of the property. The property is 20 km from Soochipara Falls.<br /><br />

                  The apartment will provide you with a cable TV and a seating area. There is a full kitchen with a refrigerator and a dining table. Featuring a bath, private bathroom also comes with a bath or shower and free toiletries. There is an additional bathroom.<br /><br />

                At Wayanad Cliff Hotels Apartments you will find a garden, a terrace and a shared kitchen. Other facilities like a shared lounge are offered. The property offers free parking.<br /><br />

              The Pookode Lake is 15 km and the Bansura Sagar Dam is 22 km. The Calicut Railway Station and the Calicut Bus Station are within 71 km. The Calicut International Airport is located 110 km from the property.<br /><br />

We speak your language!


                  </p>
                  <br />

                  <br />
                  <br />
              </div>
            </div>

            <div style={{display:'flex',flexDirection:this.state.dir,}}>
              <div style={{display:'flex',flexDirection:'column',justifyContent:'flex-start',alignItems:'center',minWidth:150}}>
                  <div><h1>{this.state.type=='room'?'Facilities:':'Itenary:'}</h1></div>
                  <div style={{background:'#0792EF',width:'50%',height:1,marginTop:2}} />
              </div>
              <div style={{margin:10,width:'100%'}}>
                <div style={{margin:20,fontSize:15}}>
                    {
                      this.state.type=='pack'?
                      <ul >
                        <li>
                           > 2nights stay in 2bhk (2bedroom Hall )Non AC apartment.
                        </li>
                        <li>
                           > Wayanad site seeing for 2days
                        </li>
                        <li>
                           > Breakfast included, others will be charged extra.
                        </li>
                        <li>
                           > Extra children will be charged Rs.300/Pax  and extra adult will be charged Rs.500/-
                        </li>
                        <li>
                           > Site seeing Places available(optional)
                        </li>
                        <li>
                           > Reservation of rooms subject to availability
                        </li>
                      </ul>:
                      <div style={{display:'flex',flexDirection:'row',justifyContent:"space-around",alignItems:'space-around',fontSize:18,font:'bold'}}>
                        <div>
                          <Icon type="wifi" style={{ fontSize: 20, color: '#1DA57A' }}/> Free WiFi<br />
                        </div>
                        <div><Icon type="key" style={{ fontSize: 20, color: '#1DA57A' }} /> Free parking<br /></div>
                        <div><Icon type="api" style={{ fontSize: 20, color: '#1DA57A' }} /> Sun terrace<br /></div>
                        <div><Icon type="picture" style={{ fontSize: 20, color: '#1DA57A' }} /> Garden<br /></div>
                      <div><Icon type="car" style={{ fontSize: 20, color: '#1DA57A' }} /> Car hire<br /></div>
                      <div><Icon type="smile" style={{ fontSize: 20, color: '#1DA57A' }} /> Family rooms</div>
                      </div>
                    }
                    <br />
                    <br />
                </div>
              </div>
            </div>

          </div>

          <div style={{background:'#fff'}}>
            <BookNow  price={Number(prop.price)} title={this.state.title}/>
          </div>
        </div>



    </div>
    )
  }
}

const mapStateToProps = ({packsel}) => ({
    data: packsel.data
});
export default connect(mapStateToProps,null)(Responsive(SinglePack));



// WEBPACK FOOTER //
// ./src/SinglePack.js